// React
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Col, Modal, Button, Row } from 'reactstrap';
import React, { useCallback, useEffect, useState } from 'react';

// Yup Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Inejections
import { ViewAssociatesDataRegister } from '../../../../../containers/componentsInjection';

// Helpers & Redux
import { cpf } from 'cpf-cnpj-validator';
import { useLoading } from '../../../../../../../hook/useLoading';
import { APIClient } from '../../../../../../../helpers/api_helper';
import {
  CreateAssociates,
  UpdateAssociates,
} from '../../../../../../../store/actions';

export const ModalEditDependent = ({
  item,
  toggle,
  isVisible,
  resetValues,
  handleSubmit,
  isCPFRequired,
}) => {
  const [associate, setAssociate] = useState();

  const api = new APIClient();
  const history = useHistory();
  const dispatch = useDispatch();
  const { loadingWithTime } = useLoading();

  // Functions
  const findAssociate = useCallback(async (id) => {
    await api
      .get(`/customer/${id}`)
      .then((associateFind) => {
        if (associateFind) {
          setAssociate(associateFind);
        }
        return false;
      })
      .catch(() => {
        return false;
      });
  }, []);

  Yup.addMethod(Yup.string, 'cpfType', function (errorMessage) {
    return this.test('cpfType', errorMessage, function (value) {
      const { path, createError } = this;

      if (cpf.isValid(value)) {
        return true;
      } else {
        createError({ path, message: errorMessage });
      }
    });
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      nameInput: associate ? associate.name : '',
      cpfInput: associate ? associate.cpf : '',
      rgInput: associate ? associate.rg : '',
      orgaoInput: associate ? associate.rg_issuer : '',
      birthdayInput: associate ? associate.birthdate : '',
      genderInput: associate && associate.gender,
      stateCivilInput: associate
        ? {
            value: associate.marital_status_id,
            label: associate.marital_status_name,
          }
        : {},
      jobInput: associate ? associate.profession : '',
      obsInput: associate ? associate.obs : '',
      emailInput: associate ? associate.email : '',
      phoneInput: associate ? associate.phones.phone1 : '',
      telInput: associate ? associate.phones.phone2 : '',
      whatsappInput: associate ? associate.phones.whatsapp : '',
      canSendMessageSelect: associate ? associate.accept_messages : true,
      zipInput: associate ? associate.zipcode : '',
      streetInput: associate ? associate.address1 : '',
      numberInput: associate ? associate.address_number : '',
      address2Input: associate ? associate.address2 : '',
      neighborhoodInput: associate ? associate.district : '',
      cityInput: associate
        ? { value: associate.city_id, label: associate.city }
        : '',
      pointInput: associate ? associate.reference_point : '',
      isActiveSelect: associate ? associate.active : true,
      isDiedSelect: associate ? associate.deceased : false,
      motherName: associate ? associate.mother_name : '',
    },

    validationSchema: Yup.object({
      nameInput: Yup.string().nullable().required('Nome é obrigatório'),
      cpfInput: isCPFRequired
        ? Yup.string().cpfType('Digite um CPF válido').nullable()
        : Yup.string().nullable(),
      birthdayInput: Yup.date()
        .nullable()
        .required('Data de nascimento é obrigatório'),
      phoneInput: Yup.string().nullable(),
      zipInput: Yup.string().nullable(),
      streetInput: Yup.string().nullable(),
      numberInput: Yup.string().nullable(),
      neighborhoodInput: Yup.string().nullable(),
      cityInput: Yup.object().nullable(),
      rgInput: Yup.string().nullable(),
      orgaoInput: Yup.string().nullable(),
      genderInput: Yup.string().nullable().required('Gênero é obrigatório'),
      stateCivilInput: Yup.object().nullable(),
      jobInput: Yup.string().nullable(),
      obsInput: Yup.string().nullable(),
      emailInput: Yup.string().nullable(),
      telInput: Yup.string().nullable(),
      whatsappInput: Yup.string().nullable(),
      canSendMessageSelect: Yup.boolean().nullable(),
      address2Input: Yup.string().nullable(),
      pointInput: Yup.string().nullable(),
      isActiveSelect: Yup.boolean().nullable(),
      isDiedSelect: Yup.boolean().nullable(),
      motherName: Yup.string().nullable(),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        name: values.nameInput || null,
        cpf: values.cpfInput || null,
        rg: values.rgInput || null,
        rg_issuer: values.orgaoInput || null,
        marital_status_id: values.stateCivilInput.value || null,
        birthdate: values.birthdayInput || null,
        gender: values.genderInput || null,
        profession: values.jobInput || null,
        email: values.emailInput || null,
        address1: values.streetInput || null,
        address2: values.address2Input || null,
        address_number: values.numberInput || null,
        reference_point: values.pointInput || null,
        district: values.neighborhoodInput || null,
        city_id: values.cityInput.value || null,
        zipcode: values.zipInput || null,
        obs: values.obsInput || null,
        photo: null,
        deceased: values.isDiedSelect,
        active: values.isActiveSelect,
        accept_messages: values.canSendMessageSelect,
        phone1: values.phoneInput || null,
        phone2: values.telInput || null,
        whatsapp: values.whatsappInput || null,
        mother_name: values.motherName || null,
      };

      try {
        loadingWithTime(1000);
        if (item) {
          dispatch(UpdateAssociates(associate.id, valuesToSubmit));
        } else {
          dispatch(CreateAssociates(valuesToSubmit, false, history));
        }
        validation.resetForm();

        const valuesToDependents = {
          ...item,
          name: values.nameInput.toUpperCase(),
          cpf: values.cpfInput,
          gender: values.genderInput,
          birthdate: values.birthdayInput,
        };

        handleSubmit(valuesToDependents);
        toggle();
        resetValues();
        // associate(null);
      } catch (err) {
        return err;
      }
    },
  });

  useEffect(() => {
    if (item?.customer_hashid) {
      findAssociate(item.customer_hashid).then((r) => null);
    }
  }, [findAssociate, item]);

  return (
    <Modal
      isOpen={isVisible}
      toggle={() => {
        toggle();
      }}
      centered
      className="modal-xl"
    >
      <Col className="modal-content border-0">
        <Col className="modal-header p-3 bg-soft-info">
          {item ? 'Editar dependente' : 'Novo dependente'}
          <Button
            onClick={() => {
              toggle();
            }}
            className="btn-close"
          ></Button>
        </Col>
        <Col className="modal-body">
          <ViewAssociatesDataRegister
            history={history}
            buttonLoading={false}
            validation={validation}
          >
            <Row className="mt-3">
              <Col className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  onClick={() => {
                    toggle();
                  }}
                  className="btn btn-link"
                >
                  Cancelar
                </button>
                <Button
                  onClick={() => {
                    validation.handleSubmit();
                  }}
                  className="btn btn-secondary"
                  id="add-btn"
                >
                  Salvar
                </Button>
              </Col>
            </Row>
          </ViewAssociatesDataRegister>
        </Col>
      </Col>
    </Modal>
  );
};
